import apiClient from '../apiClient';
import { apiBaseUrl } from '../../config';

export const manuallyDownloadInvoices = async (accountId) => {
    return apiClient.get(`${apiBaseUrl}/invoice-download/taxpayer/manual/${accountId}/invoices`, {})
    .then(response => { return response });
}

export const getLastInvoicesUpdate = async (accountId) => {
    return apiClient.get(`${apiBaseUrl}/tax-statements/taxpayer/invoices/${accountId}/update-log`, {})
    .then(response => { return response });
} 